<template>
  <v-card v-if="billingItems && billingItems.length > 0">
    <v-card-title>
      Faturas
      <v-spacer />
      <v-layout row align-center justify-space-between fill-height>
        <v-flex sm6>
          <v-select
            v-model="selectedPowerPlants"
            :items="powerPlants"
            label="Filtre por Usinas"
            multiple
          >
            <v-list-tile slot="prepend-item" ripple @click="toggle">
              <v-list-tile-action>
                <v-icon
                  :color="
                    selectedPowerPlants.length > 0 ? 'indigo darken-4' : ''
                  "
                  >{{ icon }}</v-icon
                >
              </v-list-tile-action>
              <v-list-tile-title>Selecionar Todos</v-list-tile-title>
            </v-list-tile>
            <v-divider slot="prepend-item" class="mt-2" />
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item }}</span>
              </v-chip>
              <v-chip v-if="index === 1">
                <span>{{ item }}</span>
              </v-chip>
              <span v-if="index === 2" class="grey--text caption"
                >(+{{ selectedPowerPlants.length - 2 }} outras)</span
              >
            </template>
          </v-select>
        </v-flex>
        <v-flex sm1></v-flex>
        <v-flex sm5>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="billingList"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          {{ props.item.created_at | formatarDate }}
        </td>

        <td class="text-xs-center">
          {{ props.item.process_type | formatProcessType }}
        </td>

        <td class="text-xs-center">
          {{ props.item.consumer_unit }}
        </td>
        <td class="text-xs-center">
          {{ props.item.power_plant_id }}
        </td>

        <td class="text-xs-center">
          <v-btn
            round
            small
            v-if="props.item.status === 'error'"
            @click="openBillingDebug(props.item)"
            :color="props.item.status | formatStatusBillingColor"
            text-color="white"
          >
            {{ props.item.status | formatTransactionStatus }}
          </v-btn>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                :color="props.item.status | formatStatusBillingColor"
                text-color="white"
                small
              >
                {{ props.item.status | formatTransactionStatus }}
              </v-chip>
            </template>
            <span v-if="props.item.pending_reason">
              Motivo Identificado <br />{{ props.item.pending_reason }}
            </span>
            <span v-else-if="props.item.postpone_reason">
              Motivo Identificado <br />{{ props.item.postone_reason }}
            </span>
            <span v-else> Sem Motivo Identificado </span>
          </v-tooltip>
        </td>

        <td class="text-xs-center">
          <v-icon v-if="props.item.unique_billing" color="green"
            >mdi-check-circle</v-icon
          >
          <v-icon v-else color="red">mdi-close-circle</v-icon>
        </td>

        <td class="text-xs-center">
          {{ props.item.due_date_utility | formatarDate }}
        </td>

        <td class="text-xs-center">
          {{ props.item.amount_kW ? props.item.amount_kW + "kW" : "-" }}
        </td>

        <td class="text-xs-center">
          {{ props.item.energy_kWh ? props.item.energy_kWh + "kWh" : "-" }}
        </td>

        <td class="text-xs-center">
          {{ props.item.tax ? (props.item.tax.toFixed(2) ?? 0) : "-" }}
        </td>

        <td class="text-xs-center">
          {{
            props.item.percentage_discount
              ? props.item.percentage_discount + "%"
              : "-"
          }}
        </td>

        <td class="text-xs-center">
          {{
            "R$" +
            (props.item.unique_billing
              ? (
                  (props.item.total ?? 0) - (props.item.total_invoice ?? 0)
                ).toFixed(2)
              : (props.item.total ?? 0).toFixed(2))
          }}
        </td>

        <td class="text-xs-center">
          <v-tooltip v-if="isAdmin || isFinancial" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-2 pl-2"
                v-on="on"
                color="grey"
                v-if="props.item && (isAdmin || isFinancial)"
                @click.prevent="gotoTransactionHistory(props.item.id)"
                >visibility</v-icon
              >
            </template>
            <span>Detalhe da Fatura.</span>
          </v-tooltip>

          <v-tooltip v-if="isAdmin || isFinancial" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="ml-2 pl-2"
                color="grey"
                v-if="isAdmin || isFinancial"
                @click.prevent="goToCustomerCare(props.item.consumer_unit)"
                >settings_accessibility</v-icon
              >
            </template>
            <span>Ir para tela de Atendimento.</span>
          </v-tooltip>
        </td>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Sua busca "{{ search }}" não retornou resultados.
        </v-alert>
      </template>
    </v-data-table>

    <v-dialog
      :lazy="true"
      v-model="dialog_communication"
      scrollable
      max-width="500px"
    >
      <v-card>
        <v-card-title>Comunicação</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <communication-billing v-if="billing_id" :billing_id="billing_id" />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            flat
            @click="dialog_communication = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogInformPayment" max-width="550px" persistent>
      <v-form ref="informPayment">
        <v-card>
          <v-card-title class="headline grey lighten-2"
            >Baixa Manual</v-card-title
          >
          <v-card-text>
            Informe a data de pagamento e carregue um comprovante que mostre que
            o pagamento já foi realizado há mais de 3 dias úteis
            <v-dialog
              ref="pdateDialog"
              v-model="paymentDateModal"
              :return-value.sync="paymentDate"
              persistent
              lazy
              full-width
              width="450px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="paymentDate"
                  label="Pagou em"
                  prepend-icon="date_range"
                  readonly
                  v-on="on"
                  :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                ></v-text-field>
              </template>
              <v-date-picker
                dark
                v-model="paymentDate"
                scrollable
                width="450px"
                :max="
                  new Date(
                    new Date().setDate(new Date().getDate() - 3),
                  ).toISOString()
                "
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="paymentDateModal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="$refs.pdateDialog.save(paymentDate)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
            <v-text-field
              label="Comprovante"
              @click="onPickFile"
              v-model="filename"
              prepend-icon="attach_file"
            >
            </v-text-field>
            <input
              style="display: none"
              accept="image/*, application/pdf"
              @change="detectFiles($event)"
              type="file"
              ref="receiptFile"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialogInformPayment = false">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              flat
              @click="saveInformPayment"
              :disabled="loadingDialog"
              :loading="loadingDialog"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>

    <billing-debug />
    <detalhes-fatura />
    <reprocessing
      :key="dialog_editBilling.key"
      :billing="dialog_editBilling.billing"
    />
  </v-card>
  <v-card v-else-if="loading">
    <p class="pa-4 text-md-center">
      Carregando
      <v-progress-circular
        color="purple"
        indeterminate
        size="16"
        class="mr-2"
      ></v-progress-circular>
    </p>
  </v-card>
  <v-card v-else>
    <p class="pa-4 text-md-center">Não há dados para exibir</p>
  </v-card>
</template>

<script>
import { firestorage } from "@/firebase/firestorage";
import { standardBucket } from "@/firebase/firestorageBank";
import firebase from "firebase";
import { mapMutations, mapState } from "vuex";
import BillingDebug from "../../components/billing/BillingDebug.vue";
import CommunicationBilling from "../../components/faturaDetails/CommunicationBilling.vue";
import DetalhesFatura from "../../components/faturaDetails/DetalhesFatura.vue";
import firestore from "../../firebase/firestore";
import { eventBus } from "../../main";
import { sendInvoice, updateBilling } from "../../services/billing";
import { getPermission } from "../../services/permissions";
import Reprocessing from "./Reprocessing.vue";

export default {
  components: {
    BillingDebug: BillingDebug,
    DetalhesFatura,
    CommunicationBilling,
    Reprocessing,
  },

  data() {
    return {
      search: "",
      headers: [
        {
          text: "Data de faturamento",
          align: "center",
          value: "created_at",
        },
        {
          text: "Tipo de Faturamento",
          align: "center",
          value: "process_type",
        },
        {
          text: "Unidade consumidora",
          align: "center",
          value: "consumer_unit",
        },
        { text: "Usina", align: "center", value: "power_plant_id" },
        { text: "Status", align: "center", value: "status" },
        { text: "Unificada", align: "center", value: "unique_billing" },
        {
          text: "Data de Vcto Concessionária",
          align: "center",
          value: "due_date_utility",
        },
        { text: "Qt Energia Compensada", align: "center", value: "amount_kW" },
        { text: "Consumo", align: "center", value: "energy_kWh" },
        { text: "Imposto", align: "center", value: "tax" },
        { text: "Desconto UC", align: "center", value: "percentage_discount" },
        { text: "Valor para Juntos", align: "center", value: "" },
        { text: "Ações", align: "center" },
      ],
      pag: {
        rowsPerPage: 20,
      },
      local_loading: false,
      loadingChange: false,
      color: "",
      snackMessage: "",
      snackbar: false,
      billing_id: null,
      dialog_communication: false,
      dialog_editBilling: {
        key: 0,
        billing: null,
      },
      selectedPowerPlants: [],
      billingList: [],
      loadingDialog: false,
      dialogInformPayment: false,
      paymentDateModal: false,
      paymentDate: null,
      currentFile: null,
      filename: "",
    };
  },

  watch: {
    billingItems() {
      this.billingList = this.billingItems;
    },

    selectedPowerPlants() {
      if (this.selectedPowerPlants.length === 0) {
        this.billingList = this.billingItems;
      } else {
        this.billingList = this.billingItems.filter((billing) =>
          this.selectedPowerPlants?.includes(billing?.power_plant_id),
        );
      }
    },
  },

  computed: {
    ...mapState("billing", ["billingItems", "loading"]),
    ...mapState(["user", "permissions"]),

    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("admin") >= 0;
    },

    isExternalCollection() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("external_collection") >= 0;
    },

    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("financial") >= 0;
    },

    isPartnerManagement() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("partner_management") >= 0;
    },

    powerPlants() {
      return [
        ...new Set(this.billingItems.map((billing) => billing.power_plant_id)),
      ];
    },

    likesAllPowerPlants() {
      return this.selectedPowerPlants.length === this.powerPlants.length;
    },

    likesSomePowerPlants() {
      return this.selectedPowerPlants.length > 0 && !this.likesAllPowerPlants;
    },

    icon() {
      if (this.likesAllPowerPlants) return "mdi-close-box";
      if (this.likesSomePowerPlants) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  methods: {
    ...mapMutations("billing", ["setReprocessingDialog"]),

    openBillingDebug(billing) {
      eventBus.$emit("billingDebug", billing);
    },

    gotoTransactionHistory(transaction_id) {
      eventBus.$emit("billing_id", transaction_id);
      eventBus.$emit("right", true);
    },

    goToCustomerCare(consumer_unit) {
      this.$router.push({
        path: "/atendimento/?installation_number=" + consumer_unit,
      });
    },

    goToCommunication(id) {
      this.billing_id = id;
      this.dialog_communication = true;
    },

    goToEditBilling(billing) {
      this.dialog_editBilling = {
        key: this.dialog_editBilling.key + 1,
        billing,
      };
      this.setReprocessingDialog(true);
    },

    async faturar(id, old_status) {
      try {
        this.local_loading = true;
        const permission = await getPermission("faturar", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.local_loading = false;
          return false;
        }
      } catch (err) {
        this.local_loading = false;
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }
      this.local_loading = true;
      const newBillig = {
        updated_at: new Date(),
        status: "reprocessing",
      };
      if (old_status === "pending_approval") {
        newBillig.approved_at = new Date();
        newBillig.approved_by = this.user.email;
      }

      if (old_status === "free_pending") {
        newBillig.free_approved_at = new Date();
      }

      firestore
        .collection("billing")
        .doc(id)
        .update(newBillig)
        .then(() => {
          this.local_loading = false;
          this.snack(
            "Sistema refaturando. Aguarde alguns segundos...",
            "success",
          );
        })
        .catch((err) => {
          this.local_loading = false;
          console.error(err);
          this.snack("Erro ao iniciar o refaturamento!", "error");
        });
    },

    async resendToClient(billing_id) {
      try {
        this.loadingChange = true;
        const permission = await getPermission("resend_bill", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.loadingChange = false;
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      await sendInvoice(billing_id, localStorage.getItem("token"))
        .then(() => {
          this.loadingChange = false;
          this.snack(
            "Reenvio de fatura iniciado. O reenvio acontece em até 1 minuto!",
            "green",
          );
        })
        .catch((err) => {
          this.loadingChange = false;
          this.snack(
            "Erro ao pedir reenvio de fatura. Tente novamente mais tarde. " +
              err,
            "red",
          );
          console.error(err);
        });
    },

    async reprocessingBilling(id) {
      firestore
        .collection("billing")
        .doc(id)
        .update({
          status: "reprocessing",
          invoice_url: null,
          updated_at: new Date(),
        })
        .then(() => {
          this.local_loading = false;
          this.snack("Gerando boleto. Aguarde alguns segundos...", "success");
        })
        .catch((err) => {
          this.local_loading = false;
          console.error(err);
          this.snack("Erro ao gerar boleto!", "error");
        });
    },

    async regenerateInvoice(id) {
      this.local_loading = true;
      try {
        const permission = await getPermission(
          "regenerate_billing",
          this.user.id,
        );

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.local_loading = false;
          return false;
        }
      } catch (err) {
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        this.local_loading = false;
        return false;
      }

      firestore
        .collection("billing")
        .doc(id)
        .update({
          regenerate_invoice: true,
          invoice_url: null,
          updated_at: new Date(),
        })
        .then(() => {
          this.local_loading = false;
          this.snack(
            "Regerando demonstrativo. Aguarde alguns segundos...",
            "success",
          );
        })
        .catch((err) => {
          this.local_loading = false;
          console.error(err);
          this.snack("Erro ao gerar boleto!", "error");
        });
    },

    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    async downloadResumePdf(path) {
      try {
        const permission = await getPermission("download_bill", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          return false;
        }
      } catch (err) {
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      const resumeRef = firestorage.ref(path);
      resumeRef
        .getDownloadURL()
        .then((url) => {
          console.log(url);
          window.open(url, "_blank");
        })
        .catch((error) => {
          switch (error.code) {
            case "storage/object-not-found":
              this.snack("Arquivo não encontrado!", "error");
              break;

            case "storage/unauthorized":
              this.snack(
                "Usuário não tem permissão para acessar o arquivo!",
                "error",
              );
              break;

            case "storage/canceled":
              this.snack("Usuário cancelou o download!", "error");
              break;

            case "storage/unknown":
              this.snack("Erro desconhecido!", "error");
              break;
            default:
              break;
          }
        });
    },

    toggle() {
      this.$nextTick(() => {
        if (this.likesAllPowerPlants) {
          this.selectedPowerPlants = [];
        } else {
          this.selectedPowerPlants = this.powerPlants.slice();
        }
      });
    },

    onPickFile() {
      this.$refs.receiptFile.click();
    },

    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map((x) => {
        this.currentFile = fileList[x];
      });
      this.filename = this.currentFile.name;
    },

    async saveInformPayment() {
      if (!this.currentFile) {
        this.snack("Comprovante não carregado", "top", "red");
        return false;
      }
      if (!this.$refs["informPayment"].validate()) {
        return false;
      }
      this.loadingDialog = true;
      return this.uploadFile(this.currentFile);
    },

    async uploadFile(file) {
      try {
        if (file && file.name) {
          const filePath = `comprovantes/${file.name}`;
          const metadata = { contentType: file.type };
          let uploadTask = standardBucket
            .ref()
            .child(filePath)
            .put(file, metadata);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              let progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log("Upload is " + progress + "% done");
              switch (snapshot.state) {
                case firebase.storage.TaskEvent.PAUSED:
                  console.log("Upload foi pausado");
                  break;
                case firebase.storage.TaskEvent.RUNNING: // or 'running'
                  console.log("Upload está em andamento");
                  break;
              }
            },
            (error) => {
              switch (error.code) {
                case "storage/unauthorized":
                  this.snack(
                    "Não há autorização para o upload do arquivo.",
                    "red",
                  );
                  break;
                case "storage/canceled":
                  this.snack("Upload cancelado.", "red");
                  break;
                case "storage/unknown":
                  this.snack(
                    "Ocorreu um erro inesperado, tente novamente.",
                    "red",
                  );
                  break;
              }
            },
            async () => {
              //Upload completed
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(async (downloadURL) => {
                  const update_data = {
                    status: "paid",
                    updated_at: new Date(),
                    informed_payment_date: this.paymentDate,
                    informed_receipt_url: downloadURL,
                    payment_informed_by: this.user.email,
                    payment_informed_at: new Date(),
                  };
                  await updateBilling(this.billing_id, update_data)
                    .then(() => {
                      this.dialogInformPayment = false;
                      this.loadingDialog = false;
                      this.snack("Baixa manual efetuada com sucesso!", "green");
                    })
                    .catch((err) => {
                      this.dialogInformPayment = false;
                      this.loadingDialog = false;
                      this.snack(
                        "Erro ao atualizar a fatura. " + err,
                        "top",
                        "red",
                      );
                      console.error(err);
                    });
                });
            },
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss">
#core-view
  > div
  > div:nth-child(3)
  > div
  > div
  > div
  > div
  > div
  > div.v-datatable.v-table.theme--light
  > div
  > div.v-datatable__actions__range-controls
  > button:nth-child(2)
  > div
  > i,
#core-view
  > div
  > div:nth-child(3)
  > div
  > div
  > div
  > div
  > div
  > div.v-datatable.v-table.theme--light
  > div
  > div.v-datatable__actions__range-controls
  > button:nth-child(3)
  > div
  > i {
  color: #000 !important;
}
#core-view
  > div
  > div:nth-child(3)
  > div
  > div
  > div
  > div
  > div
  > div.v-datatable.v-table.theme--light
  > div
  > div.v-datatable__actions__range-controls
  > button.v-btn.v-btn--disabled.v-btn--flat.v-btn--icon.theme--light
  > div
  > i {
  color: #bebebe !important;
}
</style>
